import { render, staticRenderFns } from "./TableOfContentsBody.vue?vue&type=template&id=9b970434&"
import script from "./TableOfContentsBody.vue?vue&type=script&lang=js&"
export * from "./TableOfContentsBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports